export { QUIZ_SCORE_RING_SIZE, QuizScore, type QuizScoreProps } from "./QuizScore"
